<template>
<div></div>
</template>
<script>
import {xml} from 'd3'
export default {
  name:'svg-map',
    props: {
        path:String,
        records: Object,
        activeClass:{ type:String, default:'active'},
        activeStyle: Object,
        deactiveStyle: Object,
    },
    mounted () {
        this.getSvg()
        
    },
    methods:{
        getSvg () {
            var self = this
            var img = xml(this.path)
            .then(function(data) {
                $(self.$el).append(data.documentElement)
                self.linkRecords()
            })
        },
        linkRecords () {
            _.each(this.records,(val,name)=>{
                if(name){
                    var el = $(this.$el).find('#'+name)
                    if(el.length){
                        if(val) this.toggleSelection(el,name)
                        el.on('click',()=>{
                            this.toggleSelection(el,name)
                        })
                    }
                }
            })
        },
        toggleSelection (el,name) {
            console.log('toggleSelection',el.attr('id'));
            el.toggleClass(this.activeClass)
            if(el.hasClass(this.activeClass)){
                el.css(this.activeStyle);
                this.records[name] = 1
            }else{
                el.css(this.deactiveStyle);
                this.records[name] = null
            }
        }
    },
}
</script>